<template>
  <div>
    <!-- Navbar -->
    <nav>
      <div class="navbar">
        <div class="nav-logo">
          <router-link :to="{ name: 'home' }" class="d-flex align-items-center">
            <img
              :src="
                logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')
              "
              class="img-fluid"
              alt="Logo"
            />
            <span
              class="ml-1"
              v-html="logo.title ? logo.title : 'IAOSHE'"
            ></span>
          </router-link>
        </div>
        <div class="sl-sm-devices white-color">
          <button
            v-if="authenticated"
            type="button"
            name="button"
            class="navbar-action"
            data-toggle="dropdown"
          >
            <div class="showDropdown">
              <img
                :src="avatar ? avatar : require('../assets/img/avatar.jpg')"
                alt=""
                class="img-fluid"
                style="width:30px;height:30px;border-radius: 50%;"
              />
              <div class="dropdown-menu">
                <router-link to="/me/profile" class="dropdown-item"
                  >Profile</router-link
                >
                <a href="javascript:;" class="dropdown-item" @click="logout()"
                  >Logout</a
                >
              </div>
            </div>
          </button>
          <router-link
            v-if="!authenticated"
            :to="{ name: 'login' }"
            class="navbar-link white-color"
          >
            Log in
          </router-link>
          <span class="ml-3 mr-3 nav-line-ver" style="line-height: 2">|</span>
          <button @click="toggleSearch = !toggleSearch" class="navbar-search">
            <span v-if="!toggleSearch" class="icon-search icon"></span>
            <span v-else class="icon-cancel icon"></span>
          </button>
        </div>
        <div id="menuBtn" class="menu-btn" @click="toggleBar = !toggleBar">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </div>
        <div class="nav-content" v-bind:class="{ active: toggleBar }">
          <!-- <button id="closeNavbar"><span>×</span></button> -->
          <div class="nav-upper">
            <!-- <a href="#" class="navbar-link">News</a> -->
            <router-link :to="{ name: 'myCertificate' }" class="navbar-link"
              >My Certificate
            </router-link>

            <button
              v-if="authenticated"
              type="button"
              name="button"
              class="navbar-action hidden-sm"
              data-toggle="dropdown"
            >
              <div class="showDropdown">
                <img
                  :src="avatar ? avatar : require('../assets/img/avatar.jpg')"
                  alt=""
                  class="img-fluid"
                  style="width:30px;height:30px;border-radius: 50%;"
                />
                <div class="dropdown-menu">
                  <router-link to="/me/profile" class="dropdown-item"
                    >Profile</router-link
                  >
                  <a href="javascript:;" class="dropdown-item" @click="logout()"
                    >Logout</a
                  >
                </div>
              </div>
            </button>
            <router-link
              v-if="!authenticated"
              :to="{ name: 'login' }"
              class="navbar-link hidden-sm"
            >
              Log in
            </router-link>

            <!-- <router-link v-if="!searchPage" :to="{ name: 'search' }" class="navbar-search hidden-sm">
              <img src="../assets/img/icons/search.svg" class="img-fluid" alt="search">
            </router-link>
            <router-link v-else :to="{ name: 'home' }" class="navbar-search hidden-sm">
              <img src="../assets/img/icons/cancel-wh.svg" class="img-fluid" alt="search">
            </router-link> -->

            <button
              @click="toggleSearch = !toggleSearch"
              class="navbar-search hidden-sm"
            >
              <span v-if="!toggleSearch" class="icon-search icon"></span>
              <span v-else class="icon-cancel icon"></span>
            </button>
          </div>
          <div class="nav-bottom">
            <div>
              <router-link
                v-if="header[0] ? header[0].status : false"
                to="/accreditations"
                class="navbar-link"
                >Accreditation</router-link
              >
            </div>
            <div>
              <router-link
                class="navbar-link"
                v-if="header[8] ? header[8].status : false"
                to="/our-certificates"
                >Certification</router-link
              >
            </div>
            <div>
              <router-link
                v-if="header[1] ? header[1].status : false"
                to="/programs"
                class="navbar-link"
                >Programs</router-link
              >
            </div>
            <div>
              <router-link
                v-if="header[2] ? header[2].status : false"
                to="/memberships"
                class="navbar-link"
                >Membership</router-link
              >
            </div>
            <div>
              <router-link
                v-if="header[3] ? header[3].status : false"
                to="/about"
                class="navbar-link"
                >About</router-link
              >
            </div>
            <div>
              <router-link
                v-if="header[4] ? header[4].status : false"
                to="/contact"
                class="navbar-link"
                >Contact Us</router-link
              >
            </div>
            <div v-for="(nav, index) in popularSearch" :key="index">
              <a
                href="javascript:;"
                @click="opnPopular(nav.slug)"
                class="navbar-link hidden-sm-links"
                >{{ nav.title }}</a
              >
            </div>
            <div>
              <router-link
                v-for="(pg, idy) in pages"
                :key="'p' + idy"
                :to="{ name: 'show-page', params: { slug: pg.slug } }"
                class="navbar-link"
                :class="pg.has_header ? '' : 'hidden'"
              >
                {{ pg.title }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <!-- Navbar -->
    <SearchPopup v-if="toggleSearch" />
  </div>
</template>

<style scoped="">
.hidden {
  display: none !important;
}
.showDropdown {
  margin-left: 10px;
  position: relative;
}
.dropdown-menu {
  right: 0;
  left: auto;
}
.navbar-search {
  font-size: 18px;
  display: flex;
  align-items: center;
}
.navbar-search .icon:before {
  color: #fff;
}
.navbar-search .icon {
  padding: 3px;
}
</style>

<script>
import axios from "axios";
import SearchPopup from "./SearchPopup";
export default {
  name: "Navbar",
  props: ["close"],
  components: {
    SearchPopup,
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: "",
      authenticated: false,
      toggleSearch: false,
      popularSearch: [],
      toggleBar: false,
    };
  },
  created() {
    axios
      .get(window.baseURL + "/popularSearch")
      .then((res) => {
        const data = res;
        this.popularSearch = res.data.rows;
        console.log(data.data);
      })
      .catch(() => {});

    if (this.$route.path == "/search") {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }

    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if (!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  methods: {
    //

    opnPopular(slug) {
      this.$router.push({
        name: "show-popular-search",
        params: { slug: slug },
      });
      // refersh
      location.reload();
    },

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = (this.logo = res.data.logo);
          this.socials = res.data.social;
          this.header = res.data.header;
        })
        .catch(() => {});
    },

    //Get Navbar Links in Big Sizes
    fetchPages() {
      axios
        .get(window.baseURL + "/pages")
        .then((res) => {
          var data = res.data.rows;
          this.pages = res.data.rows;
        })
        .catch(() => {});
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    logout() {
      localStorage.clear();
      this.$router.push({ name: "login" });
    },

    // openMenu() {
    //     let el1 = document.querySelector(".navbar-container");
    //     let el2 = document.querySelector(".navbar-backdrop");
    //     el1.classList.add('active');
    //     el2.classList.add('active');
    // },

    // closeMenu() {
    //     let el1 = document.querySelector(".navbar-container");
    //     let el2 = document.querySelector(".navbar-backdrop");
    //     el1.classList.remove('active');
    //     el2.classList.remove('active');
    // }
  },
};
</script>
